<template>
  <div class="main" @click="isShowMenu = false">
    <div class="top_title">
        <span class="fanhui" @click="getBack">
            <van-icon name="arrow-left" />
        </span>
        <span>未来已来 不"溶"错过</span>
        <!-- <span v-if="type === 1">前沿资讯</span>
        <span v-if="type === 4">直播间</span>
        <span v-if="type === 3">科研成果</span>
        <span v-if="type === 2">见证实“例”</span> -->
        <div class="menuTitle" @click.stop="isShowMenu = true">
          <img src="../assets/image/list/menuIcon1.png" alt="">
          <span>菜单</span>
        </div>
        <ul class="menuCont" v-if="isShowMenu">
          <li @click.stop="swtichType(1)" :class="{'li2': type === 1}">
            <img src="../assets/image/new/m1.png"  style="height: auto;">
            <span class="span2">前沿资讯</span>
          </li>
          <li @click.stop="swtichType(4)" :class="{'li4': type === 4}">
            <img src="../assets/image/new/m4.png" style="height: auto;">
            <span class="span4">直播间</span>
          </li>
          <li @click.stop="swtichType(2)" :class="{'li1': type === 2}">
            <img src="../assets/image/new/m2.png" style="height: auto;">
            <span class="span1">见证实“例”</span>
          </li>
          <li @click.stop="swtichType(3)" :class="{'li3': type === 3}">
            <img src="../assets/image/new/m3.png" style="height: auto;">
            <span class="span3">科研成果</span>
          </li>
        </ul>
    </div>
    <meSearch :searchVal="searchVal" @onSearch="onSearch"></meSearch>
    <van-list
      v-model="isLoading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadingMore"
      style="min-height: calc(100vh - 110px); overflow: hidden;"
    >
      <list v-if="type === 1 ||  type === 3" :listData="listData"></list>
      <video-list v-if="type === 4" :listData="listData"></video-list>
      <!-- <graceful-list v-if="type === 3" :listData="listData"></graceful-list> -->
      <instance-list v-if="type === 2" :listData="listData"></instance-list>
    </van-list>
    <van-popup v-model="showPopup" :style="{ width: '80%' , borderRadius: '10%'}">
      <img src="../assets/image/homePage/jsz.png" width="100%">
    </van-popup>
  </div>
</template>
<script>
import list from '@/comm/list.vue'
import meSearch from '@/comm/meSearch.vue'
import videoList from '@/comm/videoList.vue'
import instanceList from '@/comm/instanceList.vue'
import gracefulList from '@/comm/gracefulList.vue'
import Axios from "@/http/axios"
import allApi from "@/http/allApi.js"

export default {
  name: "homePage",
  data() {
    return {
      showPopup:false,
      isShowMenu: false,
      activeItem:0,
      searchVal:"",
      type: 1,
      page: 1,
      isLoading: false,
      finished: false,
      listData: [],
      hostType:false
    };
  },
  components: {
    list,
    meSearch,
    videoList,
    instanceList,
    gracefulList
  },    
 
  methods:{
    getBack() {
      if (window.history.length <= 2) {
            this.$router.push({path:'/'})
            return false
        } else {
            this.hostType = true;
            this.$router.go(-1)
        }
      // console.log(history.length);
    },

    onSearch(i){
      this.searchVal = i;
      this.page = 1;
      this.listData = [];
      this.finished = false
      this.getList();
    },
    swtichType(type) {
      let a = 1;
      if(type==1){
           a= 1;
      }
      if(type==2){
           a= 4;
      }
      if(type==3){
           a = 3;
      }
      if(type==4){
           a = 2;
      }    
      allApi.getCates().then(res=>{ 
        res.data.data.forEach(el => {
          if(el.id == a){
            if(el.status==0){
                this.showPopup = true;
                return;
            }else{
              if (this.type !== type) {
                this.$router.push({
                    params: {id: type}
                })
                this.type = type
                this.page = 1
                this.isShowMenu = false
                 this.finished = false
                this.listData = []
                this.searchVal = "";
                this.getList()
              }
            }
          }
        });
      })
    },
    loadingMore() {
      this.page++;
      this.getList()
    },
    async getList() {
      const info = await Axios.get("/api/index/index-lists", { params: {
        type: this.type,
        page: this.page,
        keyword:this.searchVal
      }})
      if (info.status === 200 && info.data.err_code === 0) {
        this.listData = [...this.listData, ...info.data.data];
        this.isLoading = false;
        if (info.data.data.length === 0) {
          this.finished = true
        }
      }
    }
  },
  activated(){
    // console.log("----------------1")
    // this.finished = false
    // const { params } = this.$router.history.current
    // this.type = parseInt(params.id)
    // this.isShowMenu = false
    // this.searchVal = "";
    // this.page = 1;
    // this.listData = [];
    // this.getList()
  },
  created() {
    const { params } = this.$router.history.current
    this.type = parseInt(params.id)
    this.isShowMenu = false
    this.getList()
  },
  watch:{
    $route(to,from){
      const { params } = this.$router.history.current
      let a = this.type;
      this.type = parseInt(params.id);
      if(!isNaN(this.type)){
        this.searchVal = "";
        this.page = 1;
        this.listData = [];
        this.finished = false;
        this.isLoading = false;
        if(this.hostType){
          this.hostType=false;
          this.getList();
        }
      }
      if(to.name != "List"){
        this.hostType=true;
      }
    }
  },
  mounted(){
    allApi.getShare().then(res=>{
      shareCommon(res.data.data.title,res.data.data.desc,res.data.data.img);
    })
  }
};


</script>
 <style scoped lang="less">
  .main{
    width:100%;
    height: 100%;
  }
  .top_title{
    width: 100%;
    background-color: rgb(6,160,156);
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
    text-align: center;
    box-sizing: border-box;
    color: #fff;
    font-size: 18px;
    line-height: 3.5rem;
    padding: 0rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .fanhui{
      margin-top: 3px;
    }
    .menuTitle{
      display: flex;
      align-items: center;
      img{
        width: 15px;
        height: 15px;
      }
      span{
        font-size: 18px;
        margin-left: 6px;
        margin-top: 3px;
      }
    }
    .menuCont{
      position: absolute;
      min-width: 120px;
      height: 160px;
      border-radius: 12.5px;
      box-shadow: 0px 0px 6.5px 0px rgba(153, 153, 153, 0.8);
      top: 45px;
      right: 1rem;
      z-index: 2;
      background-color: #FFFFFF;
      box-sizing: border-box;
      overflow: hidden;
      li{
        display: flex;
        align-items: center;
        height: 40px;
        padding: 0px 10px;
        img{
          width: 25px;
          height: 25px;
        }
        span{
          height: auto;
          margin-left: 7px;
          font-size: 14px;
          line-height: normal;
        }
        .span1{
          color: rgb(6,160,156);
        }
        .span2{
          color: rgb(34,140,200);
        }
        .span3{
          color: rgb(243,28,109);
        }
        .span4{
          color: rgb(114,14,186);
        }
      }
      .li1{
        background-color: rgba(6,160,156, 0.5);
      }
      .li2{
        background-color: rgba(34,140,200, 0.5);
      }
      .li3{
        background-color: rgba(243,28,109, 0.5);
      }
      .li4{
        background-color: rgba(114,14,186, 0.5);
      }
    }
  }
  /deep/.van-tabs{
    height: calc(100% - 6.8rem);
    width:100%;
    /deep/.van-tabs__content{
        height:calc(100% - 2.7rem);
        width:100%;
        overflow-y: scroll;
    }
    /deep/.van-tab__pane{
        width:100%;
        // padding:0px 5%;
    }
    /deep/.van-tabs__line{
        width: 25%;
    }
    /deep/.van-tab:nth-child(1).van-tab--active{
        color:rgb(6,160,156);
    }
    /deep/.van-tab:nth-child(2).van-tab--active{
        color:rgb(34,140,200);
    }
    /deep/.van-tab:nth-child(3).van-tab--active{
        color:rgb(243,28,109);
    }
    /deep/.van-tab:nth-child(4).van-tab--active{
        color:rgb(114,14,186);
    }
    /deep/.van-tab:nth-child(1).van-tab--active ~ .van-tabs__line{
        background-color: rgb(6,160,156);
    }
    /deep/.van-tab:nth-child(2).van-tab--active ~ .van-tabs__line{
        background-color: rgb(34,140,200);
    }
    /deep/.van-tab:nth-child(3).van-tab--active ~ .van-tabs__line{
        background-color: rgb(243,28,109);
    }
    /deep/.van-tab:nth-child(4).van-tab--active ~ .van-tabs__line{
        background-color: rgb(114,14,186);
    }
  }
</style>
